import {ApolloLink} from '@apollo/client/core';
import {map} from 'rxjs';

export const removeTypenameLink = new ApolloLink((operation, forward) => {
  return forward(operation).pipe(map(response => {
    if (response.data) {
      response.data = removeTypename(response.data);
    }
    return response;
  }));
});

function removeTypename<T>(obj: T): T {
  if (Array.isArray(obj)) {
    return obj.map(removeTypename) as T;
  } else if (obj && typeof obj === 'object') {
    const newObj: any = {};
    for (const key of Object.keys(obj)) {
      if (key !== '__typename') {
        newObj[key] = removeTypename((obj as any)[key]);
      }
    }
    return newObj;
  }
  return obj;
}
